export const defaultTrackHeadTextFunc = 'classLookup[trackHead.trackClass] + " " + trackHead.trackNumber.toString()';
